import { createContext } from 'react';
import type { UserResponse } from '@/features/users/types';
import type { ILogin } from '@/features/auth/types';

export interface AuthContextType {
  isAuthenticated: boolean;
  isLoading: boolean;
  currentUser: UserResponse | null;
  accountId: string;
  login: (credentials: ILogin) => Promise<void>;
  loginWithGoogle: (accessToken: string) => Promise<void>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);
